export function getVariant(variant: string) {
  return { variant, 'data-variant': variant };
}
